"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Guard = void 0;
const is_string_1 = require("is-string");
const lodash_1 = require("lodash");
class Guard {
    static fail(msg) {
        return { pass: false, msg };
    }
    static pass() {
        return { pass: true };
    }
    static combinedEnum(value, name, enumValues) {
        return this.combine([this.isValidEnum(value, enumValues, name)]);
    }
    static isStringEqual(value, compareTo) {
        if (!is_string_1.isString(value) || value !== compareTo) {
            return { pass: false, msg: `${parent}:${name} is invalid. Value ${JSON.stringify(value)}` };
        }
        return { pass: true };
    }
    /**
     * All guards will be executed regardless if previous ones fails so watch out when combining guards
     * which depend on each other e.g. nested.
     * @param guardResults
     */
    static combine(guardResults) {
        for (const result of guardResults) {
            if (result.pass === false) {
                console.error("validation error", result.msg);
                throw new Error(result.msg);
            }
        }
        return { pass: true };
    }
    static isString(value, name) {
        if (!is_string_1.isString(value)) {
            return { pass: false, msg: `${parent}:${name} is invalid. Value ${JSON.stringify(value)}` };
        }
        return { pass: true };
    }
    static areStrings(rawObject, parent, propsToCheck) {
        if (rawObject)
            for (const propName of propsToCheck) {
                const value = rawObject[propName];
                const guardResult = this.isString(value, propName);
                if (!guardResult.pass)
                    return guardResult;
            }
        return { pass: true };
    }
    static areMaxLength(obj, parent, argsToCheck, max) {
        if (obj) {
            const areStringsResult = this.areStrings(obj, parent, argsToCheck);
            if (!areStringsResult.pass) {
                return areStringsResult;
            }
            for (const argName of argsToCheck) {
                const result = this.isMaxLength(obj[argName], max, parent, argName);
                if (!result.pass)
                    return result;
            }
        }
        return { pass: true };
    }
    static isMaxLength(value, max, parent, argName) {
        const isNumberRes = this.isNumber(value, argName);
        if (!isNumberRes.pass) {
            return isNumberRes;
        }
        if (value.length > max) {
            return { pass: false, msg: `${parent}.${argName}.length ${value} is over ${max} limit.` };
        }
        else {
            return { pass: true };
        }
    }
    static isNumber(value, name) {
        if (value == null || isNaN(value)) {
            return { pass: false, msg: `${parent}:${name} is invalid. Value ${JSON.stringify(value)}` };
        }
        return { pass: true };
    }
    static areNumbers(rawObject, parent, propsToCheck) {
        for (const propName of propsToCheck) {
            const value = rawObject[propName];
            const guardResult = this.isNumber(value, propName);
            if (!guardResult.pass)
                return guardResult;
        }
        return { pass: true };
    }
    static isInRange(num, min, max, parent, argName) {
        if (!(num >= min && num <= max)) {
            return { pass: false, msg: `Value: ${num} of ${argName} is not within range ${min},${max}.` };
        }
        else {
            return { pass: true };
        }
    }
    static areInRange(obj, parent, argsToCheck, range) {
        if (obj)
            for (const name of argsToCheck) {
                const value = obj[name];
                const numIsInRangeResult = this.isInRange(value, range[0], range[1], parent, name);
                if (!numIsInRangeResult.pass)
                    return numIsInRangeResult;
            }
        return { pass: true };
    }
    static isValidEnum(value, enumObject, enumName) {
        if (value && !Object.values(enumObject).includes(value)) {
            return { pass: false, msg: `${value} is invalid value for ${enumName}` };
        }
        else {
            return { pass: true };
        }
    }
    static isDefined(value, name) {
        if (value == null || value === "") {
            return { pass: false, msg: `${name} is null or undefined` };
        }
        else {
            return { pass: true };
        }
    }
    static hasNrOfProps(props, name, expectedCnt) {
        const cnt = lodash_1.isObject(props) ? Object.keys(props).length : 0;
        if (expectedCnt !== cnt) {
            return {
                pass: false,
                msg: `${name} : expected # of properties mismatched. is:${expectedCnt}, expected:${expectedCnt}`,
            };
        }
        else {
            return { pass: true };
        }
    }
    static areDefined(obj, parent, propsToCheck) {
        if (obj)
            for (const propName of propsToCheck) {
                const result = this.isDefined(obj[propName], `${parent}:${propName}`);
                if (!result.pass)
                    return result;
            }
        return { pass: true };
    }
}
exports.Guard = Guard;
//# sourceMappingURL=Guard.js.map